/// <summary>
/// 搜索类型
/// </summary>
export class  SearchType  {

	constructor()
	{

		
	}
}

	/// <summary>
	/// 10表示拉框搜索
	/// </summary>
	SearchType.Bounds = 10;
	/// <summary>
	/// 5表示公交规划建议词搜索
	/// </summary>
	SearchType.BusPlanSuggest = 5;
	/// <summary>
	/// 中心点关键字搜索
	/// </summary>
	SearchType.CenterPoint = 3;
	/// <summary>
	/// 1表示普通搜索
	/// </summary>
	SearchType.Common = 1;
	/// <summary>
	/// 4表示普通建议词搜索
	/// </summary>
	SearchType.CommonSuggest = 4;
	/// <summary>
	/// 7表示 纯POI搜索(不搜公交线）
	/// </summary>
	SearchType.PurePOI = 7;
	/// <summary>
	/// 2表示视野内搜索
	/// </summary>
	SearchType.View = 2;